export function stringifyObjects(message) {
  if (isPrimitive(message)) {
    return message;
  }
  try {
    return JSON.stringify(message);
  } catch (e) {
    return message.toString();
  }
}
export function catchJSONStringifyErrors(message) {
  if (isPrimitive(message)) {
    return message;
  }
  try {
    JSON.stringify(message);
    return message;
  } catch (e) {
    return message.toString();
  }
}
function isPrimitive(object) {
  return typeof object !== "object" && typeof object !== "function" || object === null;
}
